import { z } from 'zod';

export const CoreCustomFieldScalarFieldEnumSchema = z.enum(['id','cityId','resourceType','resourceId','label','name','type','description','required','standardField','decimalPlaces','unit','picklistId','lookUpType','deactivatedAt','createdAt','updatedAt','rowTimestamp']);

export default CoreCustomFieldScalarFieldEnumSchema;
